import type { ReactNode } from 'react'
import { HeaderAppPlaceholder } from '#ui/HeaderAppPlaceholder.tsx'
import { Main } from '#ui/Main.tsx'
import { Root } from '#ui/Root.tsx'
import { SidebarPlaceholder } from '#ui/Sidebar/SidebarPlaceholder.tsx'

export function AppErrWrap(props: { children: ReactNode }) {
  return (
    <Root>
      <HeaderAppPlaceholder />
      <SidebarPlaceholder />
      <Main>{props.children}</Main>
    </Root>
  )
}
